<template>
    <v-card class="pa-3 card-historico">
        <v-row align="center">
            <v-col cols="7" class="d-flex align-center">
                <v-icon color="primary" class="mr-2">mdi-history</v-icon>
                <h4 class="bold mb-0">Histórico de status</h4>
                <v-chip
                    v-if="historicoOrdenado.length"
                    small
                    color="primary"
                    outlined
                    class="ml-2"
                >
                    {{ historicoOrdenado.length }}
                </v-chip>
            </v-col>
            <v-col cols="5" class="d-flex justify-end">
                <v-btn
                    v-if="isSuperAdmin"
                    color="success"
                    small
                    @click="abrirAdicionar"
                    :disabled="loadingHistorico || loadingSalvarHistorico"
                >
                    <v-icon small left>mdi-plus</v-icon>
                    Adicionar
                </v-btn>
            </v-col>
        </v-row>

        <v-row v-if="isSuperAdmin">
            <v-col class="py-0">
                <v-alert dense text type="info" class="mb-2 caption">
                    Área restrita a <strong>Super Admin</strong>. Toda criação,
                    edição ou exclusão grava o seu usuário e gera trilha de
                    auditoria nos comentários do título.
                </v-alert>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="pt-1">
                <div v-if="!historicoOrdenado.length" class="empty-state">
                    <v-icon large color="grey lighten-1"
                        >mdi-timeline-clock-outline</v-icon
                    >
                    <p class="grey--text mt-2 mb-0">
                        Nenhum histórico encontrado.
                    </p>
                </div>
                <div v-else class="bg-historico">
                    <div
                        v-for="status in historicoOrdenado"
                        :key="status.id_historico || status.dt_historico + status.cd_status"
                        class="historico-item"
                    >
                        <div class="historico-dot"></div>
                        <div class="historico-body">
                            <div class="d-flex align-center flex-wrap">
                                <strong class="historico-data">
                                    {{ dataExibicao(status) }}
                                </strong>
                                <v-chip
                                    x-small
                                    color="primary"
                                    outlined
                                    class="ml-2"
                                    :title="'Código do status'"
                                >
                                    #{{ codigoStatus(status) }}
                                </v-chip>
                                <v-chip
                                    v-if="status.dt_arquivo_movimento"
                                    x-small
                                    color="teal"
                                    outlined
                                    class="ml-1"
                                    title="Data de movimento do arquivo"
                                >
                                    <v-icon x-small left
                                        >mdi-file-clock-outline</v-icon
                                    >
                                    movimento
                                </v-chip>
                                <v-spacer></v-spacer>
                                <div
                                    v-if="isSuperAdmin"
                                    class="historico-actions"
                                >
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                x-small
                                                color="primary"
                                                v-bind="attrs"
                                                v-on="on"
                                                :disabled="
                                                    loadingHistorico ||
                                                        loadingSalvarHistorico
                                                "
                                                @click="abrirEdicao(status)"
                                            >
                                                <v-icon small
                                                    >mdi-pencil-outline</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Editar status / datas</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-btn
                                                icon
                                                x-small
                                                color="error"
                                                v-bind="attrs"
                                                v-on="on"
                                                :disabled="loadingHistorico"
                                                @click="pedirExclusao(status)"
                                            >
                                                <v-icon small
                                                    >mdi-trash-can-outline</v-icon
                                                >
                                            </v-btn>
                                        </template>
                                        <span>Excluir histórico</span>
                                    </v-tooltip>
                                </div>
                            </div>
                            <div class="historico-descricao">
                                {{ status.DESCRICAO }}
                            </div>
                            <div class="d-flex align-center flex-wrap mt-1">
                                <v-chip
                                    v-if="status.user_id"
                                    x-small
                                    color="indigo"
                                    outlined
                                    class="mr-1 mb-1"
                                >
                                    <v-icon x-small left
                                        >mdi-account-check-outline</v-icon
                                    >
                                    {{
                                        status.ds_login ||
                                            status.nm_user ||
                                            'usuário #' + status.user_id
                                    }}
                                </v-chip>
                                <v-chip
                                    v-else
                                    x-small
                                    outlined
                                    class="mr-1 mb-1"
                                >
                                    <v-icon x-small left>mdi-robot-outline</v-icon>
                                    sistema
                                </v-chip>
                                <v-tooltip
                                    v-if="status.user_id"
                                    top
                                    max-width="350"
                                >
                                    <template
                                        v-slot:activator="{ on, attrs }"
                                    >
                                        <v-btn
                                            x-small
                                            text
                                            color="primary"
                                            v-bind="attrs"
                                            v-on="on"
                                            class="px-1"
                                        >
                                            Detalhes
                                            <v-icon x-small right
                                                >mdi-information-outline</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <span>
                                        Ação registrada pelo usuário:
                                        <strong>{{
                                            status.ds_login || status.nm_user
                                        }}</strong>
                                        <span v-if="status.user_id">
                                            (#{{ status.user_id }})
                                        </span>
                                    </span>
                                </v-tooltip>
                                <span
                                    v-if="isAdmin && status.id_historico"
                                    class="caption grey--text ml-auto"
                                >
                                    ID {{ status.id_historico }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <!-- Confirmar exclusão -->
        <v-dialog v-model="dialogConfirm" max-width="560">
            <v-card>
                <v-card-title class="headline">
                    <v-avatar color="red lighten-5" size="40" class="mr-3">
                        <v-icon color="error">mdi-alert-circle-outline</v-icon>
                    </v-avatar>
                    Excluir histórico
                </v-card-title>
                <v-card-text>
                    <p>
                        Deseja realmente excluir este histórico? Essa ação
                        <strong>não pode ser desfeita</strong> e ficará
                        registrada na auditoria com o seu usuário.
                    </p>
                    <v-card outlined class="pa-3 grey lighten-5">
                        <div>
                            <strong>{{
                                statusSelected
                                    ? dataExibicao(statusSelected)
                                    : ''
                            }}</strong>
                            <v-chip
                                x-small
                                color="primary"
                                outlined
                                class="ml-2"
                            >
                                #{{
                                    statusSelected
                                        ? codigoStatus(statusSelected)
                                        : ''
                                }}
                            </v-chip>
                        </div>
                        <div class="mt-1">
                            {{ statusSelected.DESCRICAO }}
                        </div>
                        <div
                            v-if="statusSelected.user_id"
                            class="caption grey--text mt-1"
                        >
                            Registrado por
                            {{
                                statusSelected.ds_login ||
                                    statusSelected.nm_user
                            }}
                        </div>
                    </v-card>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        @click="dialogConfirm = false"
                        :disabled="loadingHistorico"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="error"
                        @click="deleteHistory(statusSelected.id_historico)"
                        :loading="loadingHistorico"
                    >
                        <v-icon left small>mdi-trash-can-outline</v-icon>
                        Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Adicionar / Editar -->
        <v-dialog v-model="dialogHistorico" max-width="650px" persistent>
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon left color="white">{{
                        modoEdicao ? 'mdi-pencil-circle' : 'mdi-plus-circle'
                    }}</v-icon>
                    {{
                        modoEdicao
                            ? 'Editar Histórico'
                            : 'Adicionar Novo Histórico'
                    }}
                    <v-spacer></v-spacer>
                    <v-chip
                        v-if="modoEdicao && formHistorico.id_historico"
                        small
                        color="white"
                        outlined
                    >
                        ID {{ formHistorico.id_historico }}
                    </v-chip>
                    <v-btn icon dark @click="fecharFormularioHistorico">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-6">
                    <v-alert dense outlined type="info" class="mb-4 caption">
                        <v-icon small left>mdi-shield-account-outline</v-icon>
                        Esta
                        {{ modoEdicao ? 'edição' : 'criação' }} será gravada no
                        seu usuário
                        <strong>({{ usuarioLogado }})</strong> e gerará trilha
                        de auditoria nos comentários do título.
                    </v-alert>

                    <v-card
                        v-if="modoEdicao"
                        outlined
                        class="pa-3 mb-4 grey lighten-5"
                    >
                        <div class="caption grey--text mb-1">
                            REGISTRO ORIGINAL
                        </div>
                        <div>
                            <strong>{{ resumoOriginal }}</strong>
                        </div>
                        <div
                            v-if="registroOriginal.user_id"
                            class="caption mt-1"
                        >
                            Responsável atual:
                            <strong>{{
                                registroOriginal.ds_login ||
                                    registroOriginal.nm_user ||
                                    '#' + registroOriginal.user_id
                            }}</strong>
                            → será substituído por você
                            <strong>({{ usuarioLogado }})</strong>.
                        </div>
                        <div v-else class="caption mt-1">
                            Registro de sistema → passará a constar o seu
                            usuário <strong>({{ usuarioLogado }})</strong>.
                        </div>
                    </v-card>

                    <v-form ref="formHistorico" v-model="formHistoricoValido">
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-text-field
                                    v-model="formHistorico.cd_status"
                                    label="Código do status *"
                                    outlined
                                    dense
                                    type="number"
                                    hint="Ex.: 220, 250, 105"
                                    persistent-hint
                                    :rules="regrasStatus"
                                    required
                                />
                            </v-col>
                            <v-col cols="12" sm="8">
                                <v-text-field
                                    v-model="formHistorico.dt_historico"
                                    label="Data do histórico *"
                                    outlined
                                    dense
                                    type="datetime-local"
                                    :rules="regrasDataHistorico"
                                    required
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="
                                        formHistorico.dt_arquivo_movimento
                                    "
                                    label="Data movimento (arquivo)"
                                    outlined
                                    dense
                                    type="datetime-local"
                                    hint="Opcional — limpe para remover"
                                    persistent-hint
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field
                                    v-model="formHistorico.dt_ocorrencia"
                                    label="Data ocorrência"
                                    outlined
                                    dense
                                    type="date"
                                    hint="Opcional"
                                    persistent-hint
                                    clearable
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions class="pa-6 pt-0">
                    <v-btn
                        color="success"
                        @click="salvarHistorico"
                        :loading="loadingSalvarHistorico"
                        :disabled="
                            !formHistoricoValido || loadingSalvarHistorico
                        "
                    >
                        <v-icon left>{{
                            modoEdicao ? 'mdi-content-save' : 'mdi-plus'
                        }}</v-icon>
                        {{ modoEdicao ? 'Salvar alterações' : 'Adicionar' }}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="grey"
                        text
                        @click="fecharFormularioHistorico"
                        :disabled="loadingSalvarHistorico"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <Snackbar
            data-html2canvas-ignore
            v-if="feedbackSnackbar"
            :mostrarSnackbar="feedbackSnackbar"
            :corSnackbar="feedbackSnackbarColor"
            :mensagemSnackbar="mensagemfeedbackSnackbar"
            @fecharSnackbar="feedbackSnackbar = false"
        />
    </v-card>
</template>
<script>
import moment from 'moment';
import TituloService from '@/services/TituloService';
import FalhaRetornosService from '@/services/FalhaRetornosService';
import Vue from 'vue';
export default {
    name: 'CardHistoricoStatus',
    components: {},
    props: {
        historico: {
            type: Array,
            required: true
        },
        idTitulo: {
            type: [Number, String],
            required: false,
            default: null
        },
        cdApresentante: {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            tituloService: new TituloService(Vue.http, this.$store),
            falhaRetornosService: new FalhaRetornosService(
                Vue.http,
                this.$store
            ),
            loadingHistorico: false,
            loadingSalvarHistorico: false,
            dialogConfirm: false,
            dialogHistorico: false,
            modoEdicao: false,
            formHistoricoValido: false,
            formHistorico: {
                id_historico: null,
                cd_status: '',
                dt_historico: '',
                dt_arquivo_movimento: '',
                dt_ocorrencia: ''
            },
            registroOriginal: {},
            statusSelected: {},
            feedbackSnackbar: false,
            feedbackSnackbarColor: '',
            mensagemfeedbackSnackbar: '',
            regrasStatus: [
                v => !!v || v === 0 || 'Código do status é obrigatório',
                v =>
                    /^\d+$/.test(String(v)) ||
                    'Informe um código numérico válido'
            ],
            regrasDataHistorico: [
                v => !!v || 'Data do histórico é obrigatória'
            ]
        };
    },
    computed: {
        isSuperAdmin() {
            return this.$store.getters.getSuperUser == 1;
        },
        isAdmin() {
            const getters = this.$store.getters || {};
            const user = getters.user || {};
            return (
                getters.getSuperUser == 1 ||
                getters.isAdmin == 1 ||
                user.is_admin == 1 ||
                user.is_superuser == 1 ||
                user.is_super == 1
            );
        },
        usuarioLogado() {
            const user = this.$store.getters.user || {};
            return (
                user.ds_login ||
                user.login ||
                user.nm_user ||
                user.ds_email ||
                `#${user.id_user || user.id || ''}`
            );
        },
        historicoOrdenado() {
            const lista = Array.isArray(this.historico)
                ? [...this.historico]
                : [];
            lista.forEach(ht => {
                ht.dt_ordenacao = ht.dt_arquivo_movimento
                    ? this.parseData(ht.dt_arquivo_movimento)
                    : this.parseData(
                          ht.dt_historico,
                          this.formatarDataHistoricoSafe(ht.dt_historico)
                      );
            });
            lista.sort((a, b) => {
                const da = a.dt_ordenacao
                    ? new Date(a.dt_ordenacao).getTime()
                    : 0;
                const db = b.dt_ordenacao
                    ? new Date(b.dt_ordenacao).getTime()
                    : 0;
                return db - da;
            });
            return lista;
        },
        resumoOriginal() {
            if (!this.registroOriginal || !this.registroOriginal.cd_status) {
                return '';
            }
            return `#${this.codigoStatus(
                this.registroOriginal
            )} — ${this.dataExibicao(this.registroOriginal)} — ${this
                .registroOriginal.DESCRICAO || ''}`;
        }
    },
    created() {
        moment.locale('pt-br');
    },
    methods: {
        parseData(valor, fallback) {
            if (!valor && !fallback) return null;
            const tentativa = valor || fallback;
            const m = moment(tentativa, [
                'DD/MM/YYYY HH:mm:ss',
                'DD/MM/YYYY HH:mm',
                'DD/MM/YYYY',
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm:ss',
                'YYYY-MM-DDTHH:mm',
                'YYYY-MM-DD',
                moment.ISO_8601
            ]);
            return m.isValid() ? m.toDate() : null;
        },
        formatarDataHistoricoSafe(dataHistorico) {
            if (!dataHistorico || typeof dataHistorico !== 'string') {
                return dataHistorico;
            }
            if (!dataHistorico.includes('/')) return dataHistorico;
            try {
                return this.formatarDataHistorico(dataHistorico);
            } catch (e) {
                return dataHistorico;
            }
        },
        formatarDataHistorico(dataHistorico) {
            const [data, hora] = dataHistorico.split(' ');
            const [dia, mes, ano] = data.split('/');
            const dataFormatada = `${ano}-${mes}-${dia} ` + (hora || '00:00:00');

            return dataFormatada;
        },
        dtMovimentoFormat(data) {
            const m = moment(data, [
                'DD/MM/YYYY HH:mm:ss',
                'YYYY-MM-DD HH:mm:ss',
                moment.ISO_8601
            ]);
            if (m.isValid()) return m.format('DD/MM/YYYY HH:mm:ss');
            return moment(data).format('DD/MM/YYYY HH:mm:ss');
        },
        codigoStatus(item) {
            if (!item) return '';
            return (
                item.cd_status ??
                item.cd_status_historico ??
                item.status ??
                ''
            );
        },
        dataExibicao(item) {
            if (!item) return '';
            if (item.dt_arquivo_movimento) {
                return this.dtMovimentoFormat(item.dt_arquivo_movimento);
            }
            return item.dt_historico || '';
        },
        paraInputDateTime(valor) {
            if (!valor) return '';
            let normalizado = valor;
            if (typeof valor === 'string' && valor.includes('/')) {
                const [data, hora] = valor.split(' ');
                if (data && data.includes('/')) {
                    const [dia, mes, ano] = data.split('/');
                    normalizado = `${ano}-${mes}-${dia} ${
                        hora || '00:00'
                    }`;
                }
            }
            const m = moment(normalizado, [
                'YYYY-MM-DD HH:mm:ss',
                'YYYY-MM-DDTHH:mm:ss',
                'YYYY-MM-DD HH:mm',
                'YYYY-MM-DDTHH:mm',
                'YYYY-MM-DD',
                moment.ISO_8601
            ]);
            return m.isValid() ? m.format('YYYY-MM-DDTHH:mm') : '';
        },
        paraInputDate(valor) {
            if (!valor) return '';
            let normalizado = valor;
            if (typeof valor === 'string' && valor.includes('/')) {
                const [data] = valor.split(' ');
                const [dia, mes, ano] = data.split('/');
                normalizado = `${ano}-${mes}-${dia}`;
            }
            const m = moment(normalizado, [
                'YYYY-MM-DD',
                'YYYY-MM-DD HH:mm:ss',
                moment.ISO_8601
            ]);
            return m.isValid() ? m.format('YYYY-MM-DD') : '';
        },
        formatarDataParaBackend(dataLocal, comSegundos = true) {
            if (!dataLocal) return null;
            let formatada = String(dataLocal).replace('T', ' ');
            if (formatada.length === 16) {
                formatada += ':00';
            }
            if (!comSegundos && formatada.length > 10) {
                return formatada.slice(0, 10);
            }
            return formatada;
        },
        notificar(tipo, mensagem) {
            this.feedbackSnackbar = true;
            this.feedbackSnackbarColor = tipo;
            this.mensagemfeedbackSnackbar = mensagem;
        },
        abrirAdicionar() {
            if (!this.isSuperAdmin) return;
            this.modoEdicao = false;
            this.registroOriginal = {};
            this.formHistorico = {
                id_historico: null,
                cd_status: '',
                dt_historico: moment().format('YYYY-MM-DDTHH:mm'),
                dt_arquivo_movimento: '',
                dt_ocorrencia: ''
            };
            this.dialogHistorico = true;
            this.$nextTick(() => {
                if (this.$refs.formHistorico) {
                    this.$refs.formHistorico.resetValidation();
                }
            });
        },
        abrirEdicao(status) {
            if (!this.isSuperAdmin) return;
            this.modoEdicao = true;
            this.registroOriginal = { ...status };
            this.statusSelected = { ...status };
            this.formHistorico = {
                id_historico: status.id_historico,
                cd_status: this.codigoStatus(status),
                dt_historico: this.paraInputDateTime(
                    status.dt_historico
                ),
                dt_arquivo_movimento: this.paraInputDateTime(
                    status.dt_arquivo_movimento
                ),
                dt_ocorrencia: this.paraInputDate(status.dt_ocorrencia)
            };
            this.dialogHistorico = true;
            this.$nextTick(() => {
                if (this.$refs.formHistorico) {
                    this.$refs.formHistorico.resetValidation();
                }
            });
        },
        fecharFormularioHistorico() {
            this.dialogHistorico = false;
            this.modoEdicao = false;
            this.registroOriginal = {};
            this.formHistorico = {
                id_historico: null,
                cd_status: '',
                dt_historico: '',
                dt_arquivo_movimento: '',
                dt_ocorrencia: ''
            };
            if (this.$refs.formHistorico) {
                this.$refs.formHistorico.resetValidation();
            }
        },
        pedirExclusao(status) {
            if (!this.isSuperAdmin) return;
            this.statusSelected = status || {};
            this.dialogConfirm = true;
        },
        deleteHistory(id) {
            if (!this.isSuperAdmin) return;
            this.loadingHistorico = true;

            this.tituloService
                .deleteHistoryStatus(id)
                .then(() => {
                    this.$emit('atualizaTitulo');
                    this.dialogConfirm = false;
                    this.notificar(
                        'success',
                        'Histórico excluído com sucesso!'
                    );
                })
                .catch(error => {
                    const msg =
                        error?.data?.mensagem ||
                        error?.data?.msg ||
                        'Erro ao excluir histórico!';
                    this.notificar('error', msg);
                })
                .finally(() => {
                    this.loadingHistorico = false;
                });
        },
        async salvarHistorico() {
            if (!this.isSuperAdmin) return;
            if (!this.$refs.formHistorico.validate()) {
                return;
            }

            const idTitulo =
                this.idTitulo || this.$route?.query?.id_titulo || null;

            try {
                this.loadingSalvarHistorico = true;

                if (this.modoEdicao) {
                    if (!this.formHistorico.id_historico) {
                        this.notificar(
                            'error',
                            'ID do histórico não encontrado!'
                        );
                        return;
                    }
                    const payload = {
                        cd_status: parseInt(this.formHistorico.cd_status),
                        dt_historico: this.formatarDataParaBackend(
                            this.formHistorico.dt_historico
                        ),
                        dt_arquivo_movimento: this.formHistorico
                            .dt_arquivo_movimento
                            ? this.formatarDataParaBackend(
                                  this.formHistorico.dt_arquivo_movimento
                              )
                            : null,
                        dt_ocorrencia: this.formHistorico.dt_ocorrencia
                            ? this.formatarDataParaBackend(
                                  this.formHistorico.dt_ocorrencia,
                                  false
                              )
                            : null
                    };
                    // Remove nulos para não sobrescrever sem intenção,
                    // exceto dt_arquivo_movimento que aceita null (limpar)
                    if (!payload.dt_ocorrencia) {
                        delete payload.dt_ocorrencia;
                    }

                    await this.tituloService.updateHistoryStatus(
                        this.formHistorico.id_historico,
                        payload
                    );
                    this.notificar(
                        'success',
                        'Histórico atualizado com sucesso!'
                    );
                } else {
                    if (!idTitulo) {
                        this.notificar(
                            'error',
                            'ID do título não encontrado!'
                        );
                        return;
                    }
                    const dadosHistorico = {
                        id_titulo: parseInt(idTitulo),
                        cd_apresentante: this.cdApresentante || null,
                        status: parseInt(this.formHistorico.cd_status),
                        cd_status: parseInt(this.formHistorico.cd_status),
                        data: this.formatarDataParaBackend(
                            this.formHistorico.dt_historico
                        ),
                        dt_historico: this.formatarDataParaBackend(
                            this.formHistorico.dt_historico
                        ),
                        dt_arquivo_movimento: this.formHistorico
                            .dt_arquivo_movimento
                            ? this.formatarDataParaBackend(
                                  this.formHistorico.dt_arquivo_movimento
                              )
                            : null,
                        dt_ocorrencia: this.formHistorico.dt_ocorrencia
                            ? this.formatarDataParaBackend(
                                  this.formHistorico.dt_ocorrencia,
                                  false
                              )
                            : null
                    };

                    await this.falhaRetornosService.adicionarHistoricoStatus(
                        dadosHistorico
                    );
                    this.notificar(
                        'success',
                        'Histórico adicionado com sucesso!'
                    );
                }
                this.fecharFormularioHistorico();
                this.$emit('atualizaTitulo');
            } catch (error) {
                const msg =
                    error?.data?.mensagem ||
                    error?.data?.msg ||
                    (this.modoEdicao
                        ? 'Erro ao atualizar histórico!'
                        : 'Erro ao adicionar histórico!');
                this.notificar('error', msg);
            } finally {
                this.loadingSalvarHistorico = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.card-historico {
    height: 100%;
}
.bg-historico {
    overflow: auto;
    height: 252px;
    padding: 10px 12px 10px 18px;
    border-radius: 8px;
    background: #fafbfc;
    border: 1px solid #eef0f3;
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-track {
        margin-left: 10px;
        background: #fff;
    }
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
}
.historico-item {
    position: relative;
    display: flex;
    padding: 10px 0 10px 18px;
    border-bottom: 1px solid #e8eaed;
    &:last-child {
        border-bottom: none;
    }
    &:hover {
        background: #fff;
        border-radius: 8px;
        .historico-actions {
            opacity: 1;
        }
    }
    &::before {
        content: '';
        position: absolute;
        left: 5px;
        top: 14px;
        bottom: -2px;
        width: 2px;
        background: #e0e4ea;
    }
    &:last-child::before {
        display: none;
    }
}
.historico-dot {
    position: absolute;
    left: 0;
    top: 16px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #1976d2;
    border: 2px solid #fff;
    box-shadow: 0 0 0 2px #bbdefb;
}
.historico-body {
    flex: 1;
    min-width: 0;
}
.historico-data {
    font-size: 0.85rem;
}
.historico-descricao {
    font-size: 0.85rem;
    color: #37474f;
    margin-top: 2px;
    line-height: 1.35;
}
.historico-actions {
    opacity: 0.55;
    transition: opacity 0.15s ease;
}
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 252px;
    border: 1px dashed #cfd8dc;
    border-radius: 8px;
    background: #fafbfc;
}
</style>
